<script>
import {useSecurityStore} from "@/stores/Security";
import {usePaySlipStore} from "@/stores/PaySlip";
import {usePaySlipAnnexStore} from "@/stores/PaySlipAnnex";

import MoreAction from "@/views/PaySlip/Components/MoreAction.vue";
import PaySlipFilter from "@/views/PaySlip/Components/PaySlipFilter.vue";
import CalculatorIrg from "@/views/PaySlip/Components/CalculatorIrg.vue";
import PaySlipDetails from "@/views/PaySlip/PaySlipDetails.vue";
import MorePrintAction from "@/views/PaySlip/Components/MorePrintAction.vue";

import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";

import {computed, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {storeToRefs} from "pinia";
import axios from "axios";

export default {
    props: {
        archive: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
    },
    components: {
        MorePrintAction,
        PaySlipFilter,
        MoreAction,
        PaySlipDetails,
        CalculatorIrg,
    },
    setup() {
        const securityStore = useSecurityStore();
        const paySlipStore = usePaySlipStore();
        const {$i18n} = useTools();
        const {priceFormat, transformFilterValues} = useSharedMethod();
        const {
            filter,
            loading,
            sortBy,
            descending,
            page,
            itemsPerPage,
            total,
            totalPages,
            itemColor,
        } = useSharedData();
        const rightDrawer = ref(false);

        const selected = ref([])
        const headers = ref([]);
        sortBy.value = "workerCode";
        descending.value = false;
        itemsPerPage.value = securityStore.userContext.paySlipRowsPerPage;
        filter.value = {
            phase: "ACTIVE",
            closed: securityStore.userContext.paySlipState || null,
        };

        const annexStore = usePaySlipAnnexStore();

        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                if (key === 'phase') {
                    filter.value[key] = 'ACTIVE';
                } else if (key === 'annexId') {
                    filter.value[key] = annexStore.getMax();
                } else {
                    filter.value[key] = null;
                }
            });
        }

        const selectedOne = ref({details: []});

        function findAll(selectedIndex) {
            loading.value = true;

            selectedOne.value = {details: []};
            paySlipStore.setPaySlips([]);

            filter.value.page = page.value - 1;
            filter.value.rowsPerPage = itemsPerPage.value;
            filter.value.sortBy = sortBy.value;
            filter.value.descending = descending.value;

            axios.get('/payments', {params: transformFilterValues(filter.value)}).then(response => {
                paySlipStore.setPaySlips(response.data.elements);
                total.value = response.data.total;
                totalPages.value = response.data.totalPages;

                headers.value = [];
                addHeaderHead();
                addFooterHeader();
                paySlipStore.paySlips.forEach((element) => {
                    element.details.forEach((detail) => {
                        if (detail.printIn !== "5" && detail.value !== 0) {
                            element[detail.code] = priceFormat(detail.value);
                            addHeader(detail);
                        }
                    });
                });


                if (paySlipStore.paySlips.length > 0) {
                    if (selectedIndex) {
                        select(paySlipStore.paySlips[selectedIndex]);
                    } else {
                        select(paySlipStore.paySlips[0]);
                    }
                }


            }).finally(() => {
                loading.value = false;
            })
        }

        function addHeaderHead() {
            headers.value.push(
                {
                    text: "...",
                    align: "start",
                    sortable: false,
                    value: "action",
                    ordre: -8,
                },
                {
                    text: $i18n.t("common.code"),
                    align: "start",
                    sortable: true,
                    value: "workerCode",
                    ordre: -7,
                },
                {
                    text: $i18n.t("common.last_name"),
                    align: "start",
                    sortable: true,
                    value: "workerLastName",
                    ordre: -6,
                },
                {
                    text: $i18n.t("common.first_name"),
                    align: "start",
                    sortable: true,
                    value: "workerFirstName",
                    ordre: -5,
                },
                {
                    text: $i18n.t("module.occupation"),
                    align: "start",
                    sortable: true,
                    value: "workerOccupationName",
                    ordre: -4,
                },
                {
                    text: $i18n.t("module.organizational_chart"),
                    align: "start",
                    sortable: true,
                    value: "workerOrganizationalChartName",
                    ordre: -3,
                },
                {
                    text: $i18n.t("common.grille"),
                    align: "start",
                    sortable: true,
                    value: "grille",
                    order: -2,
                }
            );
        }

        function addHeader(detail) {
            if (!headers.value.some((header) => header.value === detail.code)) {
                headers.value.push({
                    text: detail.code,
                    align: "center",
                    sortable: false,
                    value: detail.code,
                    ordre: detail.ordre + 7,
                });
            }
        }

        function addFooterHeader() {
            headers.value.push(
                {
                    text: $i18n.t("common.net"),
                    align: "start",
                    sortable: true,
                    value: "net",
                    ordre: 3000,
                },
                {
                    text: $i18n.t("common.base_imposable"),
                    align: "start",
                    sortable: true,
                    value: "baseImposable",
                    ordre: 3001,
                },
                {
                    text: $i18n.t("common.base_cotisable"),
                    align: "start",
                    sortable: true,
                    value: "baseCotisable",
                    ordre: 3002,
                },
                {
                    text: $i18n.t("pay_section.total_gains"),
                    align: "start",
                    sortable: true,
                    value: "totalGains",
                    ordre: 3003,
                },
                {
                    text: $i18n.t("pay_section.total_retenues"),
                    align: "start",
                    sortable: true,
                    value: "totalRetenues",
                    ordre: 3004,
                },
                {
                    text: "Total CNAS",
                    align: "start",
                    sortable: true,
                    value: "totalCnas",
                    ordre: 3011,
                },
                {
                    text: $i18n.t("pay_slip.masse"),
                    align: "start",
                    sortable: true,
                    value: "masse",
                    ordre: 3012,
                }
            );
        }

        function select(item) {
            selectedOne.value = item;
        }

        const annexId = computed(() => filter.value.annexId);
        const annex = ref({fermer: false});
        const annexLoading = ref(false);

        function findAnnexById() {
            annexLoading.value = true;
            axios.get(`/paySlipAnnexes/${annexId.value}`).then(response => {
                annex.value = response.data;
            }).finally(() => {
                annexLoading.value;
            });
        }

        watch(() => annexId.value, () => {
            if (annexId.value)
                findAnnexById();
        });

        function rowColor(item) {
            if (selectedOne.value.id === item.id) {
                return itemColor.value;
            } else if (item.tagName) {
                return "yellow";
            }
        }

        function getIndex() {
            return paySlipStore.paySlips.findIndex(p => p.id === selectedOne.value.id);
        }

        function previous() {
            let index = getIndex();
            if (index !== -1) {
                if (index > 0) {
                    select(paySlipStore.paySlips[index - 1]);
                } else if (page.value > 1) {
                    page.value -= 1;
                    findAll(itemsPerPage.value - 1);
                }
            } else if (paySlipStore.paySlips.length > 0) {
                select(paySlipStore.paySlips[0]);
            }
        }

        function next() {
            let index = getIndex();
            if (index !== -1) {
                if (index + 1 < paySlipStore.paySlips.length) {
                    select(paySlipStore.paySlips[index + 1]);
                } else if (page.value < totalPages.value) {
                    page.value += 1;
                    findAll();
                }
            } else if (paySlipStore.paySlips.length > 0) {
                select(paySlipStore.paySlips[0]);
            }
        }

        function handleKeyDown(event) {
            if (event.key === 'ArrowUp') {
                previous();
            }

            if (event.key === 'ArrowDown') {
                next();
            }

            /*if (event.shiftKey && event.key === "F") {
                if (selectedOne.value.id && !selectedOne.value.closed)
                    $router.push({name: 'pay_slips.close', params: {id: selectedOne.value.id}})
                event.preventDefault();
            }
            if (event.key === "Enter") {
                if (selectedOne.value.id)
                    $refs.routerViewRef.close();
                event.preventDefault();
            }
            if (event.shiftKey && event.key === "C") {
                if (selectedOne.value.id)
                    $refs.detailComponentRef.calculate();
                event.preventDefault();
            }
            if (event.shiftKey && event.key === "A") {
                if (selectedOne.value.id)
                    $refs.detailComponentRef.addPaySectionsWithoutSelectOrdre();
                event.preventDefault();
            }
            if (event.shiftKey && event.key === "Q") {
                if (selectedOne.value.id)
                    previous();
                event.preventDefault();
            }
            if (event.shiftKey && event.key === "S") {
                if (selectedOne.value.id)
                    next();
                event.preventDefault();
            }*/
        }

        onMounted(() => document.addEventListener('keydown', handleKeyDown));
        onBeforeUnmount(() => document.removeEventListener('keydown', handleKeyDown));


        watch([sortBy, descending], () => {
            findAll();
        });

        watch(() => filter.value, () => {
            page.value = 1;
            findAll();
        }, {deep: true});

        const {refresh} = storeToRefs(paySlipStore);
        watch(() => refresh.value, () => {
            findAll();
        });

        return {
            securityStore,
            paySlipStore,
            filter,
            loading,
            rightDrawer,
            sortBy,
            descending,
            page,
            itemsPerPage,
            total,
            totalPages,
            headers,
            selected,
            selectedOne,
            annexLoading,
            annex,
            findAll,
            rowColor,
            next,
            previous,
            select,
            clearFilter,
            priceFormat
        }
    },
}
</script>

<template>
    <div>
        <w-app
            :title="`${$t('module.write_pay')}: ${annex.name}`"
            :title-icon="annex.fermer ? 'mdi-lock' : null"
            title-color="orange"
            show-total
            :total="total"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <pay-slip-filter v-model="filter" auto-select-annex/>
            </template>

            <template v-slot:rightToolbar>
                <more-action :annex="annex"/>
                <more-print-action
                    v-if="securityStore.authorities['PRINT_PAY_SLIP']"
                    :filter="filter"
                />
                <calculator-irg></calculator-irg>
                <w-btn-reload :loading="loading" @press="findAll"/>
            </template>

            <template v-slot:content>
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="paySlipStore.paySlips"
                    :server-items-length="total"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="descending"
                    hide-default-footer
                    must-sort
                    single-select
                    fixed-header
                    height="280"
                    :multi-sort="false"
                    :loading="loading"
                    dense
                    @click:row="select"
                    :item-class="rowColor"
                >
                    <template v-slot:[`item.action`]="{ item }">
                        <v-menu bottom right v-if="item.updateOption">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    dark
                                    icon
                                    color="blue darken-2"
                                    v-on="on"
                                >
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>

                            <v-list nav dense>
                                <v-list-item
                                    :disabled="item.closed"
                                    @click="$router.push({name: 'pay_slips.correct', params: {annexId: item.annexId, id: item.id}})"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="orange">mdi-pencil-box-multiple</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('pay_slip.calculate_correction') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    :disabled="item.closed"
                                    @click="$router.push({name: 'pay_slips.create_empty_one', params: { workerId: item.workerId, annexId: item.annexId}})"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="'mdi-plus-circle-outline'" color="teal"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('pay_slip.create_empty_bis') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    :disabled="item.closed"
                                    @click="$router.push({name: 'pay_slips.close', params: {id: item.id}})"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey darken-2">mdi-lock</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('pay_slip.close') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    :disabled="item.closed"
                                    @click="$router.push({name: 'pay_slips.delete', params: { id: item.id }})"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="'mdi-trash-can'" color="red"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        {{ $t("common.delete") }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="$router.push({ name: 'pay_slips.documents', params: { id: item.id}})"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="'mdi-folder'" color="amber"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        {{ $t("module.edms") }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.workerCode`]="{ item }">
                        <!--<strong style="white-space: nowrap;">
                            <span v-if="item.tagName" class="red--text">
                                {{ item.tagName }} -
                            </span>
                            <span class="teal--text">{{ item.workerCode }}</span>
                            <v-icon left small color="orange" v-if="item.closed">
                                mdi-lock
                            </v-icon>
                        </strong>-->
                        <w-chip
                            :text="`${item.tagName ? item.tagName: ''} ${item.workerCode}`"
                            :icon="item.closed ? 'mdi-lock' : null"
                            icon-color="grey darken-2"
                        />

                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-inline-text bold :text="item.workerLastName"/>
                    </template>
                    <template v-slot:[`item.workerFirstName`]="{ item }">
                        <w-inline-text bold :text="item.workerFirstName"/>
                    </template>
                    <template v-slot:[`item.workerOccupationName`]="{ item }">
                        <w-inline-text :text="item.workerOccupationName"/>
                    </template>
                    <template v-slot:[`item.workerOrganizationalChartName`]="{ item }">
                        <w-inline-text :text="item.workerOrganizationalChartName"/>
                    </template>
                    <template v-slot:[`item.grille`]="{ item }">
                        <w-inline-text :text="item.grille"/>
                    </template>
                    <template v-slot:[`item.net`]="{ item }">
                        <w-chip color="teal" :text="priceFormat(item.net)"/>
                    </template>
                    <template v-slot:[`item.baseCotisable`]="{ item }">
                        {{ priceFormat(item.baseCotisable) }}
                    </template>
                    <template v-slot:[`item.baseImposable`]="{ item }">
                        {{ priceFormat(item.baseImposable) }}
                    </template>
                    <template v-slot:[`item.totalGains`]="{ item }">
                        {{ priceFormat(item.totalGains) }}
                    </template>
                    <template v-slot:[`item.totalRetenues`]="{ item }">
                        {{ priceFormat(item.totalRetenues) }}
                    </template>
                    <template v-slot:[`item.totalCnas`]="{ item }">
                        {{ priceFormat(item.totalCnas) }}
                    </template>
                    <template v-slot:[`item.masse`]="{ item }">
                        {{ priceFormat(item.masse) }}
                    </template>
                    <template v-slot:footer="{}">
                        <div class="text-center pt-2">
                            <v-row justify="center">
                                <v-col md="6">
                                    <v-pagination
                                        v-model="page"
                                        :length="Math.ceil(total / itemsPerPage)"
                                        total-visible="15"
                                        @input="findAll(0)"
                                    />
                                </v-col>
                                <v-col md="2">
                                    <w-enum-select
                                        v-model="itemsPerPage"
                                        :items="[
                                            {id: 5, name: '5'},
                                            {id: 10, name: '10'},
                                            {id: 15, name: '15'},
                                            {id: 20, name: '20'},
                                            {id: 25, name: '25'},
                                            {id: 30, name: '30'},
                                            {id: 2147483647, name: 'Tous'},
                                        ]"
                                        :label="$t('common.items_per_page')"
                                        @change="findAll()"
                                    />

                                </v-col>
                            </v-row>
                        </div>
                    </template>
                </v-data-table>
                <pay-slip-details
                    :id="selectedOne.id"
                    @previous="previous"
                    @next="next"
                    ref="detailComponentRef"
                />
            </template>

        </w-app>

        <router-view ref="routerViewRef"/>
    </div>
</template>

<style scoped>

</style>